import { millis } from '../../publicacoes/publicacao.definitions';
import type { Publicacao } from '../../publicacoes/publicacao.types';
import { useVersoesDocumentoQuery } from '../../publicacoes/usePublicacoes';
import { DrawerLateral } from './DrawerLateral';

interface HistoricoVersoesDrawerProps {
  documento: Publicacao | null;
  onClose: () => void;
}

const data = (ms: number | null) => (ms ? new Date(ms).toLocaleDateString('pt-BR') : '—');

/** Histórico de versões (só quem publica): a atual + as anteriores, cada uma com o seu arquivo. */
export function HistoricoVersoesDrawer({ documento, onClose }: HistoricoVersoesDrawerProps) {
  const { data: versoes = [], isLoading } = useVersoesDocumentoQuery(documento?.id);
  return (
    <DrawerLateral isOpen={documento != null} titulo={`Histórico · ${documento?.titulo ?? ''}`} onClose={onClose}>
      {documento && (
        <ul className="space-y-2">
          <li className="rounded-xl border border-primary-200 bg-primary-50/50 px-4 py-3 text-sm">
            <div className="flex items-center justify-between gap-3">
              <b>
                Versão {documento.versao ?? 1} <span className="text-xs font-semibold text-primary-700">(atual)</span>
              </b>
              {documento.arquivo && (
                <a href={documento.arquivo.url} target="_blank" rel="noreferrer" className="text-xs font-semibold text-primary-700">
                  Abrir
                </a>
              )}
            </div>
            <p className="text-xs text-raro-gray-500">{data(millis(documento.anunciadoEm) ?? millis(documento.publicarEm))}</p>
            {documento.oQueMudou && <p className="mt-1 text-xs text-raro-gray-700">{documento.oQueMudou}</p>}
          </li>
          {isLoading && <li className="h-14 animate-pulse rounded-xl bg-raro-gray-100" />}
          {versoes.map((v) => (
            <li key={v.id} className="rounded-xl border border-raro-gray-200 px-4 py-3 text-sm">
              <div className="flex items-center justify-between gap-3">
                <b>Versão {v.versao}</b>
                <a href={v.arquivo.url} target="_blank" rel="noreferrer" className="text-xs font-semibold text-primary-700">
                  Abrir
                </a>
              </div>
              <p className="text-xs text-raro-gray-500">
                {data(millis(v.publicadaEm))}
                {v.autor?.name ? ` · ${v.autor.name}` : ''}
              </p>
              <p className="mt-1 text-xs text-raro-gray-700">{v.oQueMudou ?? (v.versao === 1 ? 'Primeira versão' : '')}</p>
            </li>
          ))}
          {!isLoading && versoes.length === 0 && (
            <li className="text-xs text-raro-gray-500">Ainda não há versões anteriores.</li>
          )}
        </ul>
      )}
    </DrawerLateral>
  );
}
